import { z } from "zod";

export const booksSearchSchema = z.object({
  read: z.enum(["read", "reading", "unread"]).optional().catch(undefined),
  owned: z.boolean().optional().catch(undefined),
  tbr: z.boolean().optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  page: z.number().optional().catch(undefined),
  pageSize: z.number().optional().catch(undefined)
});
export type BooksSearchSchema = z.infer<typeof booksSearchSchema>;
